import { render, staticRenderFns } from "./v-accordion-group.vue?vue&type=template&id=212584e1&scoped=true&"
import script from "./v-accordion-group.vue?vue&type=script&lang=js&"
export * from "./v-accordion-group.vue?vue&type=script&lang=js&"
import style0 from "./v-accordion-group.vue?vue&type=style&index=0&id=212584e1&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "212584e1",
  null
  
)

export default component.exports